import { motion } from 'framer-motion';

export const FeatureCard = ({ icon: Icon, title, description, delay = 0 }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, delay, ease: "easeOut" }}
      className="bg-charcoal-800 border border-gray-800 rounded-2xl p-8 hover:bg-charcoal-700 hover:border-gold-500/30 transition-all duration-300 group cursor-default"
    >
      <div className="w-14 h-14 rounded-full bg-charcoal-900 flex items-center justify-center mb-6 border border-gray-700 group-hover:border-gold-500/50 group-hover:scale-110 transition-all duration-300">
        <Icon className="w-6 h-6 text-gold-500" />
      </div>
      <h3 className="text-xl font-bold text-white mb-3">{title}</h3>
      <p className="text-gray-400 leading-relaxed text-sm">
        {description}
      </p>
    </motion.div>
  );
};
